import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import initialState from '../store';
import { Tender } from '@modules/tender-platform/types';
import { tenderSearchRoutine } from '@modules/tender-platform/children/tender-search/actions';
import { TenderSearchStore } from '@modules/tender-platform/children/tender-search/types';
import { onFailure, onFulfill, onRequest } from '@common/utils/helpers/reducers';

export const searchTender = createReducer(initialState, {
  [tenderSearchRoutine.REQUEST]: onRequest,
  [tenderSearchRoutine.SUCCESS]: (
    state: TenderSearchStore,
    action: PayloadAction<{
      tenders: Array<Tender>;
    }>
  ) => {
    const { tenders } = action.payload;
    state.tenders = tenders;
    return state;
  },
  [tenderSearchRoutine.FAILURE]: onFailure,
  [tenderSearchRoutine.FULFILL]: onFulfill
});
